






























import { mapGetters } from 'vuex'
import { FadeAffectorMode, FadeAffectorConfig, FloatPropertyMode } from '../../pfx/emitterConfig'
import PropEditorFloat from "./proped-float.vue";
import { safeParseFloat, formatNumber, findAffector, removeAffector } from '../../utils'

export default {
	name: 'PropEditorAffectorFade',
    components: {
		PropEditorFloat,
    },
    props: {
        onchange: Function, 
        emitter: Object
    },
    enums: {
       FadeAffectorMode 
    },
    data: function () {
        return {
        }
    },
    methods: {
        triggerChange: function() {
            this.onchange();
        },
        createAffector: function(initialMode) {
            return {
                mode: initialMode,
                constSpeed: {
                    mode: FloatPropertyMode.Constant,
                    val: 0,
                    min: 0,
                    max: 0
                },
                target: {
                    mode: FloatPropertyMode.Constant,
                    val: 0,
                    min: 0,
                    max: 0
                },
                times: [
                    {
                        mode: FloatPropertyMode.Constant,
                        val: 0.5,
                        min: 0,
                        max: 0
                    },
                    {
                        mode: FloatPropertyMode.Constant,
                        val: 0.5,
                        min: 0,
                        max: 0
                    }
                ]
            }
        }
    },
	computed: {
        mode: {
            get() {
                let aff:FadeAffectorConfig = findAffector(this.emitter, "fade");
                if(!aff)
                    return FadeAffectorMode.Disabled;
                return aff.mode;
            },
            set(newVal:number) {
                let aff:FadeAffectorConfig = findAffector(this.emitter, "fade");
                if(!aff) {
                    aff = this.createAffector(newVal);
                    this.emitter.affectors.push({
                        id: "fade",
                        cfg: aff
                    });
                } else {
                    if(newVal == FadeAffectorMode.Disabled) {
                        removeAffector(this.emitter, "fade")
                    } else {
                        aff.mode = newVal;
                    }
                }

                this.triggerChange();
            }
        },
        constSpeed: {
            get() {
                let aff:FadeAffectorConfig = findAffector(this.emitter, "fade");
                return aff.constSpeed;
            },
        },
        target: {
            get() {
                let aff:FadeAffectorConfig = findAffector(this.emitter, "fade");
                return aff.target;
            }
        },
        times0: {
            get() {
                let aff:FadeAffectorConfig = findAffector(this.emitter, "fade");
                return aff.times[0];
            }
        },
        times1: {
            get() {
                let aff:FadeAffectorConfig = findAffector(this.emitter, "fade");
                return aff.times[1];
            }
        }
	}
}
